import { render, staticRenderFns } from "./Properties.vue?vue&type=template&id=5921309a&"
import script from "./Properties.vue?vue&type=script&lang=js&"
export * from "./Properties.vue?vue&type=script&lang=js&"
import style0 from "./Properties.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports